import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'success-issue',
})
class Success extends Vue {
  @Prop() close;
}
export default Success;
